// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpcomingBookingSkeleton-bookingSkeletonCardContainer-gbC9V {
    background: var(--background-primary);
    padding: 24px;
    border-radius: var(--radius-3);
}

.UpcomingBookingSkeleton-bookingSkeletonCardSpace-N7Vkl {
    margin-top: 24px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardTitle-E5JaR {
    max-width: 132px;
    height: 26px;
    margin-bottom: 18px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.UpcomingBookingSkeleton-bookingSkeletonCardListContainer-EV47w {
    display: grid;
    gap: 18px;
    grid-gap: 18px;
}

.UpcomingBookingSkeleton-bookingSkeletonCard-ocil8 {
    border: 1px solid var(--primary-border);
    padding: 18px;
    border-radius: var(--radius-3);
    background: var(--background-primary);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 18px;
    grid-gap: 18px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardImg-TAydR {
    position: relative;
    width: 100%;
    max-width: 144px;
    height: 144px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
    -ms-flex-negative: 0;
        flex-shrink: 0;
    background: var(--skeleton-secondary-bg);
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoBox-tP1WN {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    grid-gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoLsContainer-z2rIC {
    text-align: start;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoTitle-eEqUD,
.UpcomingBookingSkeleton-bookingSkeletonCardInfoDesc-Wv1FS {
    background: var(--skeleton-secondary-bg);
    margin-bottom: 6px;
    border-radius: var(--radius-5);
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoTitle-eEqUD {
    max-width: 92px;
    height: 28px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoDesc-Wv1FS {
    max-width: 253px;
    height: 26px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoLargeDesc-x6BP1 {
    max-width: 347px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoSmallDesc-Dd84g {
    max-width: 109px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoRsContainer-IuCL6 {
    background: var(--skeleton-secondary-bg);
    padding: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    border-radius: var(--radius-2);
    min-width: 136px;
    max-width: 254px;
    gap: 12px;
    grid-gap: 12px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoIdTitle-OtNqc,
.UpcomingBookingSkeleton-bookingSkeletonCardInfoIdDesc-RwtQ4 {
    border-radius: var(--radius-5);
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoIdTitle-OtNqc {
    max-width: 100%;
    height: 32px;
}

.UpcomingBookingSkeleton-bookingSkeletonCardInfoIdDesc-RwtQ4 {
    max-width: 68px;
    height: 26px;
}

@media (max-width: 1199px) and (min-width: 992px) {
    .UpcomingBookingSkeleton-bookingSkeletonCardImg-TAydR {
        max-width: 110px;
        height: 110px;
    }
}

@media (max-width: 991px) {
    .UpcomingBookingSkeleton-bookingSkeletonCard-ocil8 {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
    }

    .UpcomingBookingSkeleton-bookingSkeletonCardImg-TAydR {
        max-width: 100%;
    }

    .UpcomingBookingSkeleton-bookingSkeletonCardInfoBox-tP1WN {
        max-width: 100%;
        width: 100%;
    }
}

@media (max-width: 991px) and (min-width: 768px) {
    .UpcomingBookingSkeleton-bookingSkeletonCardImg-TAydR {
        height: 200px;
    }
}

@media (max-width: 767px) {
    .UpcomingBookingSkeleton-bookingSkeletonCardInfoBox-tP1WN {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
        width: 100%;
    }

    .UpcomingBookingSkeleton-bookingSkeletonCardInfoRsContainer-IuCL6 {
        min-width: unset;
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/UpcomingBookingSkeleton/UpcomingBookingSkeleton.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kDAAkD;IAClD,oBAAc;QAAd,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;;IAEI,wCAAwC;IACxC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;IAClB,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,oBAAc;QAAd,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;AACJ;;AAGA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".bookingSkeletonCardContainer {\n    background: var(--background-primary);\n    padding: 24px;\n    border-radius: var(--radius-3);\n}\n\n.bookingSkeletonCardSpace {\n    margin-top: 24px;\n}\n\n.bookingSkeletonCardTitle {\n    max-width: 132px;\n    height: 26px;\n    margin-bottom: 18px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.bookingSkeletonCardListContainer {\n    display: grid;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.bookingSkeletonCard {\n    border: 1px solid var(--primary-border);\n    padding: 18px;\n    border-radius: var(--radius-3);\n    background: var(--background-primary);\n    display: flex;\n    align-items: flex-start;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.bookingSkeletonCardImg {\n    position: relative;\n    width: 100%;\n    max-width: 144px;\n    height: 144px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n    flex-shrink: 0;\n    background: var(--skeleton-secondary-bg);\n}\n\n.bookingSkeletonCardInfoBox {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    grid-gap: 12px;\n    flex-grow: 1;\n}\n\n.bookingSkeletonCardInfoLsContainer {\n    text-align: start;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n}\n\n.bookingSkeletonCardInfoTitle,\n.bookingSkeletonCardInfoDesc {\n    background: var(--skeleton-secondary-bg);\n    margin-bottom: 6px;\n    border-radius: var(--radius-5);\n}\n\n.bookingSkeletonCardInfoTitle {\n    max-width: 92px;\n    height: 28px;\n}\n\n.bookingSkeletonCardInfoDesc {\n    max-width: 253px;\n    height: 26px;\n}\n\n.bookingSkeletonCardInfoLargeDesc {\n    max-width: 347px;\n}\n\n.bookingSkeletonCardInfoSmallDesc {\n    max-width: 109px;\n}\n\n.bookingSkeletonCardInfoRsContainer {\n    background: var(--skeleton-secondary-bg);\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    flex-direction: column;\n    flex-shrink: 0;\n    border-radius: var(--radius-2);\n    min-width: 136px;\n    max-width: 254px;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.bookingSkeletonCardInfoIdTitle,\n.bookingSkeletonCardInfoIdDesc {\n    border-radius: var(--radius-5);\n}\n\n.bookingSkeletonCardInfoIdTitle {\n    max-width: 100%;\n    height: 32px;\n}\n\n.bookingSkeletonCardInfoIdDesc {\n    max-width: 68px;\n    height: 26px;\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .bookingSkeletonCardImg {\n        max-width: 110px;\n        height: 110px;\n    }\n}\n\n\n@media (max-width: 991px) {\n    .bookingSkeletonCard {\n        flex-direction: column;\n    }\n\n    .bookingSkeletonCardImg {\n        max-width: 100%;\n    }\n\n    .bookingSkeletonCardInfoBox {\n        max-width: 100%;\n        width: 100%;\n    }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n    .bookingSkeletonCardImg {\n        height: 200px;\n    }\n}\n\n@media (max-width: 767px) {\n    .bookingSkeletonCardInfoBox {\n        flex-direction: column;\n        align-items: stretch;\n        width: 100%;\n    }\n\n    .bookingSkeletonCardInfoRsContainer {\n        min-width: unset;\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingSkeletonCardContainer": `UpcomingBookingSkeleton-bookingSkeletonCardContainer-gbC9V`,
	"bookingSkeletonCardSpace": `UpcomingBookingSkeleton-bookingSkeletonCardSpace-N7Vkl`,
	"bookingSkeletonCardTitle": `UpcomingBookingSkeleton-bookingSkeletonCardTitle-E5JaR`,
	"bookingSkeletonCardListContainer": `UpcomingBookingSkeleton-bookingSkeletonCardListContainer-EV47w`,
	"bookingSkeletonCard": `UpcomingBookingSkeleton-bookingSkeletonCard-ocil8`,
	"bookingSkeletonCardImg": `UpcomingBookingSkeleton-bookingSkeletonCardImg-TAydR`,
	"bookingSkeletonCardInfoBox": `UpcomingBookingSkeleton-bookingSkeletonCardInfoBox-tP1WN`,
	"bookingSkeletonCardInfoLsContainer": `UpcomingBookingSkeleton-bookingSkeletonCardInfoLsContainer-z2rIC`,
	"bookingSkeletonCardInfoTitle": `UpcomingBookingSkeleton-bookingSkeletonCardInfoTitle-eEqUD`,
	"bookingSkeletonCardInfoDesc": `UpcomingBookingSkeleton-bookingSkeletonCardInfoDesc-Wv1FS`,
	"bookingSkeletonCardInfoLargeDesc": `UpcomingBookingSkeleton-bookingSkeletonCardInfoLargeDesc-x6BP1`,
	"bookingSkeletonCardInfoSmallDesc": `UpcomingBookingSkeleton-bookingSkeletonCardInfoSmallDesc-Dd84g`,
	"bookingSkeletonCardInfoRsContainer": `UpcomingBookingSkeleton-bookingSkeletonCardInfoRsContainer-IuCL6`,
	"bookingSkeletonCardInfoIdTitle": `UpcomingBookingSkeleton-bookingSkeletonCardInfoIdTitle-OtNqc`,
	"bookingSkeletonCardInfoIdDesc": `UpcomingBookingSkeleton-bookingSkeletonCardInfoIdDesc-RwtQ4`
};
module.exports = ___CSS_LOADER_EXPORT___;
